import { IntlShape } from 'react-intl';
import { GridColDef } from '@mui/x-data-grid-pro';
import { DataGridColumnsFactory } from 'components/common/dataGrid/columnsFactory';
import { ContractOnView } from 'shared/domain/contract/types/view';

export class ContractColumnsFactory extends DataGridColumnsFactory<ContractOnView> {
  constructor(intl: IntlShape, timezone: string) {
    super(intl, timezone);
  }

  create(): GridColDef<ContractOnView>[] {
    return [
      this.orderNumber(),
      this.contractLabel(),
      this.contractParties(),
    ];
  }
}
